import React from 'react';

import User from 'components/Tvendo/Setting/User/List.js';

export default function () {
  return <User />;
}
